import { FaInfoCircle } from "react-icons/fa";
import type { CSSProperties, ReactNode } from "react";

export const MediaGenerationInfoParagraph = ({
  text,
  customStyle,
}: {
  text: ReactNode;
  customStyle?: CSSProperties | null;
}) => {
  return (
    <div
      className="mt-3 flex flex-row items-start"
      style={{ fontSize: "0.8rem", ...(customStyle || {}) }}
    >
      <FaInfoCircle
        style={{
          color: "rgb(37 99 235)",
          height: "0.8rem",
          width: "0.8rem",
          flexShrink: 0,
          marginTop: "0.15rem",
        }}
      />
      <p className="text-blue-600 ml-2 leading-snug">{text}</p>
    </div>
  );
};
